<template>
  <div class="server-layout">
    <h2>共享平台注册经营者合作协议书</h2>
    <div class="server-header"><span class="bold">甲 方：</span>{{name}}</div>
    <div class="server-header"><span class="bold">注册地址：</span>{{address}}</div>
    <div class="server-header"><span class="bold">乙 方：</span>身份证号：</div>
    <div class="container">

      <!-- 提示条款 -->
      <div class="tip-section">
        <div class="tip-title">提示条款</div>
        <p>欢迎您与【智云众包平台】签署本协议。本协议为您以自由职业者身份通过本平台承接任务、获取收益的法律文件。</p>
        <p><strong>【签约】</strong>当您完成注册、实名认证并点击确认，即表示您已充分理解并同意接受本协议全部内容，与甲方及甲方关联公司（即甲方园区）建立合作关系，并同意与甲方关联公司（甲方园区）签署《共享平台注册经营者合作协议书》。本协议不适用《劳动法》《劳动合同法》，双方关系受《民法典》及相关民事法律法规调整。</p>
        <p><strong>【重要提示】</strong>甲方作为灵活用工服务平台，受关联公司（甲方园区）委托负责扫码签约、认证、合同签署及信息管理等服务。本协议项下的税务处理、申报缴纳等事务由甲方关联公司依法合规处理，具体由甲方协调安排。</p>
      </div>

      <!-- 协议条款 -->
      <div class="agreement-section">
        <div class="section-title">协议条款</div>

        <!-- 第一条 -->
        <div class="article">
          <div class="article-title">第一条 合作内容与方式</div>
          <div class="clause">1.1 乙方自愿以甲方平台为渠道，承接发包方发布的任务，从事生产活动。任务的具体要求、标准及规则以发包方在平台发布的任务信息为准。</div>
          <div class="clause">1.2 乙方应独立、自主完成承揽任务，对任务成果质量负责。如违反任务规则或发包方要求，甲方有权终止合作，并扣除未结算收入作为赔偿。</div>
          <div class="clause">1.3 乙方确认与发包方、甲方、甲方关联公司（甲方园区）均不存在劳动、劳务或雇佣关系，系独立市场主体。</div>
        </div>

        <!-- 第二条 -->
        <div class="article">
          <div class="article-title">第二条 协议效力</div>
          <div class="clause">2.1 本协议自乙方完成注册认证并点击确认后立即生效，有效期一年。期满未续签但仍继续合作的，视为自动顺延。</div>
          <div class="clause">2.2 甲方有权根据业务需要修订本协议，修订后公示即生效。乙方继续使用平台服务视为接受修订。</div>
        </div>

        <!-- 第三条 -->
        <div class="article">
          <div class="article-title">第三条 甲方的权利和义务</div>
          <div class="clause">3.1 甲方为乙方提供任务信息展示、交易撮合、收入结算等技术服务，并按发包方确认的结算标准向乙方支付个人所得。</div>
          <div class="clause">3.2 甲方有权对乙方的注册信息、任务完成情况进行审核与监督，发现违规有权立即终止合作。</div>
          <div class="clause">3.3 甲方承诺对乙方提供的个人信息承担保密义务，仅用于本协议项下的服务管理。</div>
          <div class="clause">3.4 甲方受关联公司（甲方园区）委托，负责与乙方的签约、活体认证、电子合同签署（甲方园区与乙方需要签署的《共享平台注册经营者合作协议书》）、账户管理等前端服务事项。</div>
        </div>

        <!-- 第四条 -->
        <div class="article">
          <div class="article-title">第四条 乙方的权利和义务</div>
          <div class="clause">4.1 乙方有权拒绝违法违规的任务要求。</div>
          <div class="clause">4.2 乙方应提供真实、准确、完整的身份信息及收款账户信息，并在信息变更时及时更新。提供虚假信息导致的一切后果由乙方承担。</div>
          <div class="clause">4.3 乙方应独立完成承揽任务，自行承担完成任务所需的设备、工具及成本费用。</div>
          <div class="clause">4.4 乙方应自行购买商业保险，任务过程中的人身、财产安全责任由乙方自行承担。如因乙方原因造成发包方、第三方或甲方损失的，甲方有权追偿并直接扣除相应款项。</div>
          <div class="clause">4.5 乙方承诺与发包方不存在以下关系：</div>
          <div class="clause">（1）劳动关系或类似劳动人事关系；</div>
          <div class="clause">（2）关联企业（持股25%以上或被同一方控制25%以上股权）的劳动人事关系；</div>
          <div class="clause">（3）担任发包方及其关联企业的法定代表人、董事、监事、股东。</div>
          <div class="clause">4.6 乙方确认其并非军人、公职人员等国家法律规定和纪律规定禁止从事兼职或经商的人员。</div>
          <div class="clause">4.7 乙方应遵守保密义务，不得泄露发包方、甲方及任务相关的商业秘密与保密信息。</div>
        </div>

        <!-- 第五条 -->
        <div class="article">
          <div class="article-title">第五条 收入结算与支付</div>
          <div class="clause">5.1 甲方或甲方关联公司（甲方园区）向乙方支付税后个人所得，具体金额根据乙方实际服务情况、发包方结算规则及用户评价确定。</div>
          <div class="clause">5.2 乙方的个人所得税及其他法定税费由甲方关联公司（甲方园区）依法代征代缴，税后净额支付至乙方实名账户。税务申报、缴纳等具体操作由甲方协调关联公司（甲方园区）完成。</div>
          <div class="clause">5.3 乙方应确保提供的收款账户信息准确有效，因账户问题导致无法到账的损失由乙方自行承担。</div>
        </div>

        <!-- 第六条 -->
        <div class="article">
          <div class="article-title">第六条 违约责任</div>
          <div class="clause">6.1 双方应按本协议约定履行，如有违反，守约方有权要求对方及时改正；造成对方损失的，守约方有权要求违约方赔偿。如乙方因违约行为给甲方或发包商造成损失的，甲方或发包商有权直接从乙方的应得税后个人所得收入中扣除相应的款项作为赔偿。</div>
          <div class="clause">6.2 在合同因违约而终止情况下， 守约方可以要求违约方承担违约责任并赔偿损失，赔偿损失的范围应包括守约方因违约方违约所受到的全部经济损失（包括直接损失、间接损失以及因此赔偿所引发的一切合理费用的支出），守约方还可保留进一步追究的权利。</div>
          <div class="clause">6.3 因不可抗力造成损失的，彼此不负赔偿责任，但发生不可抗力一方应及时将有关情况通知另一方，并尽最大努力进行补救。本协议所称不可抗力是指不能预见、不能克服并不能避免且对一方当事人造成重大影响的客观事件，包括但不限于自然灾害如洪水、地震、火灾和风暴等，社会事件如战争、动乱、政府行为、黑客事件、大范围电信事故等，以及政府行为、政策法律改变等。</div>
        </div>

        <!-- 第七条 -->
        <div class="article">
          <div class="article-title">第七条 协议的终止</div>
          <div class="clause">7.1 本协议在发生下列情形之一时，本协议自动终止：</div>
          <div class="clause">（1）本协议到期，双方未决定继续合作的；</div>
          <div class="clause">（2）乙方主动提出终止任务，且已经发包商同意的；</div>
          <div class="clause" >（3）发包商终止或变更业务模式而不需要乙方继续履行本协议的；</div>
          <div class="clause">（4）发包商认为乙方不适合继续承揽任务的；</div>
          <div class="clause">（5）法律法规或政策变更，不再允许双方继续以此模式合作的。</div>
          <div class="clause">7.2 发生以下情形时之一的，甲方可以终止本协议：</div>
          <div class="clause" >（1）乙方被证实符合本协议第4.5条、第4.6条的情况而不适宜承揽本平台上的任务的；</div>
          <div class="clause" >（2）乙方的能力、态度或完成任务的成果如未能达到甲方或发包商的要求，甲方在自行发现乙方的瑕疵或收到发包商的通知，且经甲方核实确认乙方所完成的任务确有瑕疵时，甲方将对乙方给予警告并责令乙方改正；如乙方限期内未能予以改正或此后如仍发生类似情况的，甲方可单方面解除本协议；</div>
          <div class="clause">（3）乙方因违反发包商的规定或相应的操作规范，导致发包商有充分的理由认为乙方不适合继续承揽发包商发包的任务的；</div>
          <div class="clause" >（4）乙方提供虚假信息，从事违法活动，或侵害甲方、发包商、他人的人身、财产或其他权益，情节恶劣或造成严重损失的。</div>
          <div class="clause">7.3 本协议的终止不影响已经产生的权利义务关系，也不解除各方的保密义务。</div>
        </div>

        <!-- 第八条 -->
        <div class="article">
          <div class="article-title">第八条 其他约定</div>
          <div class="clause">8.1 因履行本协议发生的纠纷，双方应友好协商解决，协商不成的，提请北京仲裁委员会仲裁，仲裁裁决为一裁终局，对双方具有约束力。</div>
          <div class="clause">8.2 甲方有权根据业务变化情况修改本协议条款并保留对本协议条款的解释权。</div>
          <div class="clause">8.3 本协议未约定事项，适用平台公示的规则及《民法典》相关规定。</div>
          <div class="clause">8.4 乙方明确知悉并同意：甲方系受甲方关联子公司（甲方园区）委托开展本协议项下的签约、认证与信息管理服务，甲方有权将相关数据与信息提供予关联子公司用于税务处理等合法用途。</div>
        </div>

        <!-- 签署区域 -->
        <div class="signature">
          <div class="signature-party">
            <div class="signature-label">甲方：</div>
            <div class="signature-date">时间：</div>
          </div>
          <div class="signature-party">
            <div class="signature-label">乙方：</div>
            <div class="signature-date">时间：</div>
          </div>
        </div>
      </div>
    </div>
    <br>
  </div>
</template>
<script>

export default {
  name: 'server',
  data () {
    return {
      time: 9000,
      name: '',
      address: ''
    }
  },
  mounted () {
    this.name = this.$route.query.name
    this.address = this.$route.query.address
  },
  methods: {
    agreeded () {
      this.$router.push({
        name: 'userInfo',
        params: {
          id: true
        }
      })
    }
  }
}
</script>
<style scoped lang="less">
.container {
  max-width: 1200px;
  margin: 0 auto;
  background: #fff;
  padding: 40px;
  border-radius: 8px;
  box-shadow: 0 0 15px rgba(0,0,0,0.05);
}
h1 {
  text-align: center;
  color: #2c3e50;
  margin-bottom: 40px;
  font-weight: 600;
  border-bottom: 2px solid #3498db;
  padding-bottom: 15px;
}
.tip-section {
  background: #f8f9fa;
  border-left: 4px solid #f39c12;
  padding: 20px;
  margin-bottom: 30px;
  border-radius: 4px;
}
.tip-title {
  font-size: 18px;
  color: #e67e22;
  margin-bottom: 10px;
  font-weight: 600;
}
.agreement-section {
  margin-bottom: 30px;
}
.section-title {
  font-size: 20px;
  color: #2980b9;
  margin: 25px 0 15px;
  font-weight: 600;
}
.article {
  margin-left: 20px;
  margin-bottom: 20px;
}
.article-title {
  font-size: 17px;
  color: #2c3e50;
  margin-bottom: 10px;
  font-weight: 500;
}
.clause {
  margin-left: 30px;
  margin-bottom: 12px;
  text-align: justify;
}
.signature {
  display: flex;
  justify-content: space-between;
  margin-top: 60px;
  padding-top: 30px;
  border-top: 1px solid #ddd;
}
.signature-party {
  text-align: center;
  width: 30%;
}
.signature-label {
  font-weight: 500;
  margin-bottom: 40px;
  color: #2c3e50;
}
.signature-line {
  border-bottom: 1px solid #333;
  height: 20px;
  margin-bottom: 10px;
}
@media (max-width: 768px) {
  .container {
    padding: 20px;
  }
  h1 {
    font-size: 24px;
  }
  .signature {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .signature-party {
    width: 80%;
    margin-bottom: 30px;
  }
  .clause {
    margin-left: 15px;
  }
}
  .server-layout{
    color: #333;
    padding: 50px 40px;
    text-align: left;
    h2{
      text-align: center;
      font-size: 38px;
    }
    .bold{
      font-weight: bold;
    }
    .tips{
      font-size: 30px;
      font-weight: bold;
      padding: 10px 0;
    }
    .server-header{
      font-size: 30px;
    }
    .intext{
      font-size: 14px;
    }
    .agree-btn{
      display: block;
      margin: 0 auto;
    }
  }

</style>
